export default "__VITE_ASSET__BNyaDyju__"